import { render, staticRenderFns } from "./multiplechiocedouble.vue?vue&type=template&id=f85aef78&scoped=true&"
import script from "./multiplechiocedouble.vue?vue&type=script&lang=js&"
export * from "./multiplechiocedouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85aef78",
  null
  
)

export default component.exports